import PolicyLayout from "../components/PolicyLayout";
import { Mail, MapPin, Clock } from "lucide-react";

const ContactPage = () => {
  return (
    <PolicyLayout title="Contact Us" lastUpdated="February 2026">
      <p className="text-base leading-relaxed mb-10">
        We're here to help — whether you're in India or anywhere else in the
        world. Reach out for order questions, custom requests, photo-book
        consultations, or anything else. We usually respond within one
        business day (Mon–Sat, IST).
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 not-prose mb-10">
        <div className="bg-card border border-border/60 p-6">
          <Mail className="w-6 h-6 mb-3" />
          <div className="label-uppercase text-muted-foreground mb-2">
            Email
          </div>
          <a
            href="mailto:contact@thesnuggleprints.com"
            className="font-bold text-lg"
            data-testid="contact-email"
          >
            contact@thesnuggleprints.com
          </a>
          <p className="text-sm text-muted-foreground mt-2">
            Response time: within 24 hours
          </p>
        </div>

        <div className="bg-card border border-border/60 p-6">
          <Mail className="w-6 h-6 mb-3" />
          <div className="label-uppercase text-muted-foreground mb-2">
            Quick Support
          </div>
          <a
            href="mailto:contact@thesnuggleprints.com"
            className="font-bold text-lg"
            data-testid="contact-phone"
          >
            contact@thesnuggleprints.com
          </a>
          <p className="text-sm text-muted-foreground mt-2">
            Email is our preferred support channel
          </p>
        </div>

        <div className="bg-card border border-border/60 p-6">
          <MapPin className="w-6 h-6 mb-3" />
          <div className="label-uppercase text-muted-foreground mb-2">
            Registered Address
          </div>
          <address
            className="not-italic text-base font-medium leading-relaxed"
            data-testid="contact-address"
          >
            The Happy Prints Company
            <br />
            (trading as theSnugglePrints)
            <br />
            Flat 102, UKN Esperanza, Block G
            <br />
            Thubarahalli Extension Road, Whitefield
            <br />
            Bengaluru 560066, Karnataka
            <br />
            India
          </address>
          <p className="text-xs text-muted-foreground mt-3">
            Udyam Registration No. UDYAM-KR-03-0766778
          </p>
        </div>

        <div className="bg-card border border-border/60 p-6">
          <Clock className="w-6 h-6 mb-3" />
          <div className="label-uppercase text-muted-foreground mb-2">
            Business Hours
          </div>
          <div className="text-base font-medium leading-relaxed">
            Monday – Saturday
            <br />
            10:00 AM – 7:00 PM IST
          </div>
          <p className="text-sm text-muted-foreground mt-2">
            Closed on public holidays
          </p>
        </div>
      </div>

      <h3 className="text-2xl font-bold mt-10 mb-4">Grievance Officer</h3>
      <p className="text-base leading-relaxed mb-2">
        In accordance with applicable Indian law, our Grievance Officer can be
        contacted at:
      </p>
      <ul className="list-disc ml-6 space-y-1 mb-6">
        <li>Name: Bharath G</li>
        <li>Email: contact@thesnuggleprints.com</li>
        <li>Hours: Mon–Fri, 10:00–18:00 IST</li>
      </ul>

      <p className="text-sm text-muted-foreground mt-10">
        For order-specific questions, please include your reference number
        (e.g., <em>PET-YYYYMMDD-XXXXXX</em>) in your email so we can help you
        faster.
      </p>
    </PolicyLayout>
  );
};

export default ContactPage;
